import { render, staticRenderFns } from "./MonthlyTaxAlliance.vue?vue&type=template&id=34ae1824"
import script from "./MonthlyTaxAlliance.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxAlliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports